import React, { createContext, useState, useContext, useMemo } from 'react';
import PropTypes from 'prop-types';

// Provides a context for managing the pickup location.
const PickUpLocationContext = createContext(undefined);

/**
 * Custom hook for accessing the pickup location context.
 * This must be used within a `PickupLocationProvider`.
 */
export const usePickUpLocation = () => {
	const context = useContext(PickUpLocationContext);
	if (context === undefined) {
		throw new Error('usePickUpLocation must be used within a PickupLocationProvider');
	}
	return context;
};

/**
 * Provider component that supplies the pickup location context to its children.
 */
export const PickUpLocationProvider = ({ children }) => {
	const [selectedPickUpLocation, setSelectedPickUpLocation] = useState(null);

	// Memoize the context value to prevent unnecessary re-renders.
	const value = useMemo(
		() => ({
			selectedPickUpLocation,
			setSelectedPickUpLocation,
		}),
		[selectedPickUpLocation],
	);

	return (
		<PickUpLocationContext.Provider value={value}>{children}</PickUpLocationContext.Provider>
	);
};

PickUpLocationProvider.propTypes = {
	children: PropTypes.node.isRequired,
};
